<template>
  <div id="app">
    <div style="width: 100vw;display: flex;flex-direction: column;align-items: center;justify-content: center;"
      v-if="flag">
      <img src="./assets/img/error1.png" style="width: 126px;height: auto;margin-top: 150px;" />
      <div
        style="margin-top: 20px;font-size: 16px;width: 100%;box-sizing: border-box;padding: 0 20px; line-height: 30px;text-align: center;">
        为了让您拥有更好的使用体验</div>
      <div
        style="margin-top: 15px;font-size: 14px;width: 100%;box-sizing: border-box;padding: 0 20px;color: #727272;text-align: center;">
        请在电脑浏览器打开使用</div>
      <div style="width: 90vw;height: 48px;
background: linear-gradient( 62deg, #194DFC 0%, #448DF8 100%);
box-shadow: 0px 6px 10px 0px #D6E4FE;
border-radius: 8px;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;text-align: center;
line-height: 48px;margin-top: 70px;" @click="handleClipboard">复制链接</div>
    </div>
    <router-view v-if="!flag" />
  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  data() {
    return {
      flag: false
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(val, 'val'); //新路由信息
        console.log(oldval, 'oldval'); //老路由信息
        // if (val.name == 'login') {
        //     this.isLogin = true
        // } else {
        //     this.isLogin = false
        //     this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        //     this.$forceUpdate()
        // }
      },
      // 深度观察监听
      deep: true
    },
    dataFromStore(newData, oldData) {
      // 当store中的数据更新时，这里会被触发
      console.log('Store data updated:', newData);
      this.userInfo = JSON.parse(newData)
    }
  },
  created() {

  },
  mounted() {
    // 检测用户代理
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      this.flag = true
      // document.body.innerHTML = "<div>该网站不支持移动设备访问，请使用电脑浏览器打开。</div>";
      // document.body.innerHTML = `<img src="./assets/img/i11.png"/>`
      // document.body.style.display = "block"; // 显示内容
    } else {

    }
  },
  computed: {
    dataFromStore() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    handleClipboard(event) {
      console.log(event);
      const clipboard = new Clipboard(event.target, {
        text: () => 'https://laoshiai.cn/'
      })
      clipboard.on('success', () => {
        this.clipboardSuccess()
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.clipboardError()
        clipboard.destroy()
      })
      clipboard.onClick(event)
    },
    clipboardSuccess() {
      this.$message.success('复制成功')
    },
    clipboardError() {
      this.$message.error('复制失败')
    },
    openPage(index) {
      this.list.forEach((e) => {
        e.select = false
      })
      this.list[index].select = true

      const routes = {
        0: '/home/homePage',
        1: '/resources',
        2: '/assistant/assistantList',
        3: '/message'
      }

      if (routes[index]) {
        this.$router.replace(routes[index])
        sessionStorage.setItem('selectedRouteIndex', index)
      }
    }
  }
}
</script>
<style lang="scss">
::v-deep {
  

  code {
    /*元素内的空白保留，并允许换行*/
    white-space: pre-wrap !important;
    /*是否允许在单词内断句*/
    word-wrap: break-word !important;
    font-family: PingFang;
  }

  .katex-html {
    // display: none !important;
  }

  annotation {
    display: none !important;
  }

  table {
    border-collapse: collapse;
    /* 确保表格的边框线会合并为单一的线条 */
    border: 1px solid black;
    /* 设置表格的边框 */
  }

  td,
  th {
    border: 1px solid black;
    /* 设置单元格的边框 */
  }

  h1 {
    font-size: 16px;
    font-weight: bold;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
  }

  li {
    font-size: 16px;
  }
}

.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line2_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

textarea {
  border: none;
  outline: none;
  /*边线不显示*/
  resize: none;
  /*禁止拉伸*/
  background: transparent;
  /*带点绿*/
  appearance: none;
}

#app {}
</style>
